import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

export const generatePrompt = {
  getPrompt: async (): Promise<APIResponse<string>> => {
    const response = await axiosInstance.public.get(
      'https://api-fast.kreaitor.ai/api/v1/text-to-image/random/prompt'
    );

    return response.data;
  },
};
